<template>
  <div>
    <div @click="showRiskLevelInfo()"><slot></slot></div>
    <v-dialog v-model="showRiskLevelInfoPopup" color="white" width="560">
      <v-card
        v-if="showRiskLevelInfoPopup && selectedRiskLevelInfo"
        width="530"
        class="pull-left mr-2 definition-card"
      >
        <v-card-title
          class="text-h6 mb-3 py-1 mr-0 definition-card-title"
          :style="selectedRiskLevelInfo.bgStyle"
        >
          <v-row>
            <v-col class="py-0" cols="10">
              <span class="pr-1"
                >{{ selectedRiskLevelInfo.riskCategoryNameDisplay }}:</span
              >
              <span>{{ selectedRiskLevelInfo.name }}</span>
            </v-col>
            <v-col class="py-0 px-0 text-right" cols="2">
              <v-btn
                text
                small
                title="Close"
                @click="showRiskLevelInfoPopup = false"
              >
                <v-icon small color="#ffffff">fas fa-times</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-subtitle class="definition-card-subtitle mt-4">
          <p>{{ selectedRiskLevelInfo.highlight }}</p>
          <ul>
            <li
              v-for="(detail, index) in selectedRiskLevelInfo.details"
              :key="index"
            >
              {{ detail }}
            </li>
          </ul>
        </v-card-subtitle>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import lodashGet from "lodash/get";
import lodashFind from "lodash/find";

import { RISK_LEVELS } from "@/common/constants/controlRisks/risks";
import { RISK_RATING_DESCRIPTIONS } from "@/common/constants/controlRisks/risks";

export default {
  name: "RiskRatingDefinition",
  props: {
    /**
     * A list of required properties
     * @returns {riskCategoryId: String, riskValue: Number, riskCategoryNameDisplay: String}
     */
    riskCategoryInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showRiskLevelInfoPopup: false,
      selectedRiskLevelInfo: null,
    };
  },
  methods: {
    showRiskLevelInfo() {
      this.showRiskLevelInfoPopup = true;
      const selectedRatingInfo = lodashFind(RISK_RATING_DESCRIPTIONS, {
        id: this.riskCategoryInfo.riskCategoryId,
      });
      let selectedRatingselectedLevelInfo = lodashFind(
        selectedRatingInfo.levels,
        {
          value: this.riskCategoryInfo.riskValue,
        }
      );
      const rating = lodashFind(RISK_LEVELS, [
        "value",
        this.riskCategoryInfo.riskValue,
      ]);
      const color = lodashGet(rating, "bgColor");
      selectedRatingselectedLevelInfo.name = lodashGet(rating, "name");
      selectedRatingselectedLevelInfo.bgStyle = {
        "background-color": color,
      };
      selectedRatingselectedLevelInfo.riskCategoryNameDisplay = this.riskCategoryInfo.riskCategoryNameDisplay;
      this.selectedRiskLevelInfo = selectedRatingselectedLevelInfo;
    },
  },
};
</script>

<style scoped>
.definition-card {
  max-height: 500px;
  overflow-y: auto;
}
.definition-card-title {
  color: #ffffff;
  text-transform: capitalize;
}
.definition-card-subtitle {
  font-size: 12px;
}
</style>
